import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import ReCAPTCHA from "react-google-recaptcha";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";

import Input from "../../Components/Input";
import ActionNotifications from "../../Components/ActionNotifications";
import useFetch from "../../Hooks/useFetch";
import { apiBaseURL, recaptchSiteKey } from "../../Utils/ProjectConstants";
import atlasLogo from "../../Assets/images/AtlasLogo-white.png";
import "./styles.css";

/*********NOTE -> the domains is not in Natasha's recaptcha. only domain in it is flat-d0462 ********/

export default function RequestSecurityCode() {
  const navigate = useNavigate();
  const fetch = useFetch(navigate);

  const [state, setState] = useState({
    email: "",
    emailError: false,
    // recaptchaValue: "",
    // recaptchaValueError: false,
    showSpinner: false,
    notifications: [],
  });
  // const recaptchError = state.recaptchaValueError ? "recaptchError" : null;
  // let captcha;
  // const reset = () => {
  //   captcha.reset();
  // };
  const onInput = (e) => {
    setState({ ...state, [e.target.name]: e.target.value, emailError: false });
  };

  const requestCode = async () => {
    let stateValues = { ...state, notifications: [] };

    // if (stateValues.emailError && stateValues.recaptchaValueError) {
    if (stateValues.emailError) {
      stateValues.notifications.push({
        isMessageInGDStanding: false,
        message: "Please fix all error(s) before submitting.",
      });
    }

    if (stateValues.email === "") {
      stateValues.emailError = true;
      stateValues.notifications.push({
        message: "Email is required.",
        isMessageInGDStanding: false,
      });
      // return setState(stateValues);
    }
    // if (stateValues.recaptchaValue === "") {
    //   stateValues.recaptchaValueError = true;
    //   stateValues.notifications.push({
    //     message: "reCAPTCHA verification is required.",
    //     isMessageInGDStanding: false,
    //   });
    //   return setState(stateValues);
    // }

    setState({ ...state, showSpinner: true });
    // if (!stateValues.emailError && !stateValues.recaptchaValueError) {
    if (!stateValues.emailError) {
      setState({ ...state, timer: 0, showSpinner: true });
      const response = await fetch.get(
        `${apiBaseURL}/api/Account/SendSecurityCode?userEmail=${state.email}`
      );

      if (response.success && response.data.statusCode === true) {
        navigate("/login/verifySecurityCode", {
          state: { email: state.email },
        });
      } else {
        setState({
          ...stateValues,
          showSpinner: false,
          notifications: [
            ...stateValues.notifications,
            ...(response.data?.messeges || []).map((msg) => ({
              message: msg,
              isMessageInGDStanding: false,
            })),
          ],
        });
      }
    }
  };

  const renderGrid = () => {
    return (
      <div className="renderFadeIn row g-0">
        <div className="mb-4">
          <h1>Recover Password</h1>
          <h4 className="message">Don't worry, happens to the best of us.</h4>
        </div>
        <div>
          <form onSubmit={requestCode}>
            <Input
              isError={state.emailError}
              name="email"
              onChange={onInput}
              value={state.email}
              labelTitle="Email Address"
              className="mb-4"
              type="text"
            />
            {/* <h6 className="gray">ReCAPTCHA(refresh if not immediately shown):</h6>
          <div className="col-12 mb-3 captcha">
            <ReCAPTCHA
              theme="dark"
              ref={(e) => {
                captcha = e;
              }}
              className={`${recaptchError} text-start`}
              sitekey={recaptchSiteKey}
              onChange={(value) =>
                setState({
                  ...state,
                  recaptchaValue: value,
                  recaptchaValueError: false,
                })
              }
              onExpired={
                (() => reset(),
                () => {
                  setState({
                    ...state,
                    recaptchaValueError: true,
                    recaptchaValue: "",
                  });
                })
              }
              onErrored={() => {
                setState({
                  ...state,
                  recaptchaValueError: true,
                  recaptchaValue: "",
                  notifications: [].concat(state.notifications, [
                    {
                      isMessageInGDStanding: false,
                      message:
                        "An error occured with recaptcha verification. Please try again, and if the problem persists, contact the ATLAS software team.",
                    },
                  ]),
                });
              }}
            />
          </div> */}
            <button
              // onClick={requestCode}
              type="submit"
              className="col-12 button yellowBG mb-3"
            >
              {state.showSpinner ? (
                <FontAwesomeIcon
                  icon={faSpinner}
                  className="fa-spin"
                  size="lg"
                  fontWeight={700}
                />
              ) : (
                "Email Security Code"
              )}
            </button>
          </form>
          <h5 className="noBold darkGray return">
            Return to{" "}
            <Link className="linkText yellow" to="/login">
              Login
            </Link>
          </h5>
        </div>
      </div>
    );
  };
  return (
    <div id="LoginPage" className="inner ">
      <div id="ResetPassword" className="mt-5 resetpage p-md-5 p-lg-3 col-12">
        <ActionNotifications arrayOfToasts={state.notifications} />
        <div className="reset-container text-center mt-5 col-lg-4 col-12 me-5 p-4">
          <div className="row mb-3">
            <div className="col-12">
              <img alt="Atlas Logo" src={atlasLogo} width="125" />
            </div>
          </div>
          <div className="row g-0">{renderGrid()}</div>
        </div>
      </div>
    </div>
  );
}
